import { createContext, useContext, ReactNode } from 'react';

import { useSyncJob } from './use-sync-job';

type SyncJobContextValue = ReturnType<typeof useSyncJob>;

const SyncJobContext = createContext<SyncJobContextValue | null>(null);

export function SyncJobProvider({ children }: { children: ReactNode }) {
  const value = useSyncJob();
  return (
    <SyncJobContext.Provider value={value}>{children}</SyncJobContext.Provider>
  );
}

export function useSyncJobContext(): SyncJobContextValue {
  const ctx = useContext(SyncJobContext);
  if (!ctx) {
    throw new Error('useSyncJobContext must be used within SyncJobProvider');
  }
  return ctx;
}
